import React from 'react'
import { hashColor } from '../utils/colorHash'

export default function LanguageBadge({ language, size = 'sm' }) {
  const color = hashColor(language)
  const bgColor = color.replace('rgb(', 'rgba(').replace(')', ', 0.15)')

  return (
    <span
      className={`badge badge-${size}`}
      style={{
        backgroundColor: bgColor,
        color: color,
        border: 'none',
      }}
    >
      {language}
    </span>
  )
}
